/* global require $ */
require('./main.scss');

require('./image/logo.svg');
require('./image/logo-icon.svg');
require('./image/logo-purple.svg');
require('./image/laptop.png');

require('./image/automatic-plans.png');
require('./image/incorporate.png');
require('./image/instant-planning.png');

require('./image/big-obstacle.png');
require('./image/capture-those-leads.png');
require('./image/frictionless.png');
require('./image/labour.png');
require('./image/no-training.png');
require('./image/quoting-yourself.png');
require('./image/time-is-money.png');
require('./image/your-planner.png');

require('./image/detailed-banner.png');
require('./image/blogs-banner.jpg');

require('./image/planning-banner.png');
require('./image/automation-banner.png');
require('./image/incorporate-banner.png');

require('./image/banner.mp4');
require('./image/poster.jpg');

// Favicons
require('./image/favicon/apple-touch-icon.png');
require('./image/favicon/favicon-32x32.png');
require('./image/favicon/favicon-16x16.png');
require('./image/favicon/site.webmanifest');
require('./image/favicon/safari-pinned-tab.svg');
require('./image/favicon/mstile-150x150.png');

//Social
require('./image/social/facebook.svg');
require('./image/social/instagram.svg');
require('./image/social/linkedin.svg');

// Blogs
require('./image/blog/critical-importance-of-handrail-system.jpeg');
require('./image/blog/5-ways-our-3d-planner-will-boost-your-business.jpeg');
require('./image/blog/3D-planner.jpeg');
require('./image/blog/time-management.jpg');

const $ = (window.jQuery = require('jquery'));

fancyLabels = function (sel) {
	$(sel).focus(function () {
		$(this).parent('.row').addClass('move-label');
	});

	$(sel).blur(function () {
		if (!$(this).val()) {
			$(this).parent('.row').removeClass('move-label');
		}
	});
};

contactForm = function (sel) {
	$(sel).submit(function (e) {
		var me = this;
		var $me = $(me);
		e.preventDefault();

		$me.find('input, select, textarea').removeClass('error');
		$.post(me.action, $me.serializeArray(), function (data) {
			if (data.success) {
				if (window.gtag) {
					window.gtag('event', 'submit', {
						event_category: 'Form',
						event_label: window.location.pathname,
					});
				}
				me.reset();
				$me.find('.alert').html(data.message);
				return;
			}
			for (var key in data.errors) {
				$me.find('[name=' + key + ']').addClass('error');
			}
		});
	});
};

revealFooter = function (sel) {
	if ($(window).height() > $(sel).outerHeight()) {
		$footerHeight = $(sel).outerHeight();
		$prev = $(sel).prev();
		$prev.css('margin-bottom', $footerHeight);
		if (!$(sel).hasClass('fixed-footer')) {
			$(sel).addClass('fixed-footer');
		}
	}
};

gaTriggers = function (sel) {
	$(sel).click(function () {
		gtag('event', 'click', {
			event_category: $(this).data('ga-category'),
			event_label: $(this).data('ga-label'),
		});
	});
};

$(function () {
	revealFooter('footer');
	fancyLabels('input, select, textarea');
	contactForm('form.contact-form');
	gaTriggers('.js-track');

	$('.menu-icon').click(function () {
		$('nav').toggleClass('active');
	});

	$('.menu-links a, .btn').click(function () {
		if ($('nav').hasClass('active')) {
			$('nav').removeClass('active');
		}
	});

	$('.js-scroll').click(function (e) {
		var target = $(this.hash);
		if (target.length) {
			e.preventDefault();
			$('html, body').animate({ scrollTop: target.offset().top }, 500);
		}
	});
});

$(window).on('resize', function () {
	revealFooter('footer');
});
